export default __webpack_public_path__ + "static/media/ag-dropdown.204628da.webp";